<template>
  <div class="component">
    <div
      class="img"
      v-for="item in bgImgs"
      :key="item.url"
      :style="{
        backgroundImage: `url(${item.url})`,
        height: `${item.height}px`,
      }"
    />
    <div
      class="img"
      :style="{
        position: 'absolute',
        zIndex: -1,
        top: 0,
        left: 0,
        backgroundImage: `url(${imgInfo.url})`,
        height: `${imgInfo.height}px`,
      }"
    />
    <!-- <div
      class="line-replace"
      v-for="item in lines"
      :key="item.url"
      v-lazy:background-image="item.url"
      :style="{top: item.top + 'px'}"
    /> -->
  </div>
</template>

<script>
  import {VueExtend} from 'godspen-lib';
  const Vue = window.Vue;
  const VueLazyLoad = window.VueLazyLoad;
  Vue.use(VueLazyLoad);

  export default {
    mixins: [VueExtend.mixin],
    name: 'business-image-bg',
    label: process.env.LABEL,
    style: process.env.STYLE,
    stack: true, // 是否是堆叠模式 ，false：孩子元素会按楼层一个个向下排布， true: 孩子元素绝对定位，随意放置位置
    childLimit: 9999,  // 孩子元素最大限制数
    leaf: false, // 是否是叶子节点，为true的时候该节点下面不能添加节点
    props: {
        imgs: {
            type: [Array, Object],
            default: () => ({
              url: 'https://h5.bestwehotel.com/storage/download/3a4fd61b-f818-4def-bd51-0ce4ab4c515c/we_1704883638878.jpg',
              height: 6389,
              width: 750,
            }),
            editor: {
              ignore: true,
            },
        }
    },
    data() {
      return {
        imgInfo: {
          url: '',
          height: '',
        },
        bgImgs: [],
        lines: [],
      }
    },
    watch: {
      imgs: {
        deep: true,
        immediate: false,
        handler: 'calcBgImgs'
      },
    },
    editorMethods: {
    },
    mounted() {
      this.calcBgImgs();
    },
    methods: {
      calcBgImgs() {
        if (this.imgs[0]) {
          // 兼容版本2及以下
          this.bgImgs = this.imgs.map(item => ({url: item, height: 375}));
        }
        if (this.imgs.url) {
          const url = this.imgs.url;
          let height = this.imgs.height;
          const width = this.imgs.width;

          const offsetWidth = this.$el ? this.$el.offsetWidth : 375;
          const ratio = width / offsetWidth;
          height = height / ratio;

          this.imgInfo = {
            url,
            height,
          }

          // let imgHeight = 800; // 固定值800，1屏左右，不用innerheight，是为了可以放在cdn缓存用，第一次加载白屏太久了
          let imgHeight = 400; // 固定值400，400半屏左右，不用innerheight，是为了可以放在cdn缓存用
          if (imgHeight > height) {
            imgHeight = height;
          }
          const element = `${url}?x-oss-process=image/crop,h_${Math.ceil(imgHeight * ratio)},y_0`;
          this.bgImgs = [{
            url: element,
            height: imgHeight,
          }];

          // const imgs = [];
          // const lines = [];
          // let imgHeight = 0;
          // let usedHeight = 0;
          // while (usedHeight < height) {
          //   if (imgHeight === 0) {
          //     imgHeight = 100;
          //   } else {
          //     imgHeight = 300;
          //   }
          //   if (imgHeight + usedHeight > height) {
          //     imgHeight = height - usedHeight;
          //   }
          //   const element = `${url}?x-oss-process=image/crop,h_${Math.ceil(imgHeight * ratio)},y_${Math.ceil(usedHeight * ratio)}`;
          //   imgs.push({url: element, height: imgHeight});
          //   usedHeight += imgHeight;

          //   const lineUrl = `${url}?x-oss-process=image/crop,h_${Math.ceil(4 * ratio)},y_${Math.ceil((usedHeight - 2) * ratio)}`;
          //   const lineTop = usedHeight - 2;
          //   lines.push({url: lineUrl, top: lineTop});
          // }
          // this.bgImgs = imgs;
          // lines.pop();
          // this.lines = lines;
        }
      }
    }
  }
</script>

<style>
  body,html {
    overflow: hidden;
  }
</style>

<style lang="stylus" scoped>
  .line-replace {
    position absolute
    left 0
    z-index -1
    width 100%
    height 4px
    background 0 0/100% 100% no-repeat;
  }
  .component {
    width: 100%;
    height: 100%;
    position relative
    z-index 0
  }
  .img {
    user-select: none;
    display block
    margin 0 auto
    max-width 100%
    min-width 100%
    background 0 0/100% 100% no-repeat
    // transform translateZ(0) // 加这个会导致白线和轻微错位
  }
</style>



// WEBPACK FOOTER //
// src/index.vue